/**
 * View As (v109 §2, §3): an Admin-only simulation of another role's shell. It changes what the UI renders and never
 * the stored role; the server keeps authorizing the real user. Acceptance (§19): "Admin View As changes UI
 * simulation without changing stored user role."
 */
import { ROLES } from './roleNav.js'

export const VIEW_AS_KEY = 'lp-staging-view-as'

export function canViewAs(actualRole) {
  return actualRole === 'admin'
}

/** The role the shell renders for. Only an admin may simulate; anyone else always gets their own role. */
export function effectiveRole(actualRole, viewAs) {
  if (!canViewAs(actualRole)) return actualRole
  if (!viewAs || viewAs === actualRole || !ROLES.includes(viewAs)) return actualRole
  return viewAs
}

/** Roles the View As menu offers: every role but the admin's own. */
export function viewAsOptions(actualRole) {
  return canViewAs(actualRole) ? ROLES.filter(r => r !== actualRole) : []
}

export function readViewAs(storage) {
  try { return storage?.getItem(VIEW_AS_KEY) || null } catch { return null }
}

export function writeViewAs(storage, role) {
  try {
    if (role) storage?.setItem(VIEW_AS_KEY, role)
    else storage?.removeItem(VIEW_AS_KEY)
  } catch { /* private mode: the simulation just does not persist across reloads */ }
}
